module.exports = __webpack_public_path__ + "media/components/NewAsset/icons/possessions-b433b9d816f331457ecebb64c8f44ba7.svg";